import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import { Slide } from "react-slideshow-image";

import Image from "next/image";
import Link from "next/link";

import Me01 from "@/public/static/images/me-01.png";
import Me02 from "@/public/static/images/me-02.png";
import Me03 from "@/public/static/images/me-03.png";
import Me04 from "@/public/static/images/me-04.png";
import Me05 from "@/public/static/images/me-01.png";

import Me06 from "@/public/static/images/4_logo_1.png";
import Me07 from "@/public/static/images/4_drone_1.png";

import Me08 from "@/public/static/images/me-08.png";

function design_media() {
  const img: any = "/static/images/s-media.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  const images = [
    "/static/images/4_web-design-1.jpg",
    "/static/images/4_web-design-2.jpg",
    "/static/images/4_web-design-3.jpg",
    "/static/images/4_web-design-4.jpg",

    "/static/images/4_digital_content_1.jpg",
    "/static/images/4_digital_content_2.jpg",
    "/static/images/4_digital_content_3.jpg",
    "/static/images/4_digital_content_4.jpg",

    "/static/images/4_packaging_1.png",
    "/static/images/4_packaging_2.png",
    "/static/images/4_packaging_3.png",
    "/static/images/4_packaging_4.png",
    "/static/images/4_packaging_5.png",

    "/static/images/4_flyer_1.png",
    "/static/images/4_flyer_2.png",

    "/static/images/4_catalog_1.png",
    "/static/images/4_catalog_2.png",
    "/static/images/4_catalog_3.png",
    "/static/images/4_catalog_4.png",

    "/static/images/4_instore_1.png",
    "/static/images/4_instore_2.png",
    "/static/images/4_instore_3.png",
  ];

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center Me0-heading-spr">
              <h1 className="lh-1">
                <span className="fw-bolder t-pink mb-3">
                  Effective visual design
                </span>{" "}
                can make a{" "}
                <span className="fw-bolder t-pink mb-3">
                  significant impact
                </span>{" "}
                on the success of a business.
              </h1>
              <h2 className="mb-3">
                In today's competitive market, the visual appeal of a brand
                <br />
                can make a significant difference in attracting and retaining
                customers.
              </h2>
            </div>
          </div>
          <div className="row justify-content-md-center mt-3">
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-pink mb-3">
                    Memorable Brand Identity
                  </h1>
                  <Image
                    loading="lazy"
                    src={Me01}
                    alt="Memorable Brand Identity"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-4">
                    Design plays a crucial role in creating a memorable brand
                    identity that resonates with the target audience. It helps
                    creating a unique and recognizable identity for a brand,
                    making it easily recognizable for customers.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-pink mb-3">
                    Brand Connectivity
                  </h1>
                  <Image
                    loading="lazy"
                    src={Me02}
                    alt="Brand Connectivity"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-4">
                    The right combination of colors, typography, images, and
                    other design elements can evoke specific emotions and help
                    customers connect with the brand on a deeper level.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-pink mb-3">
                    Build Trust
                  </h1>
                  <Image
                    loading="lazy"
                    src={Me03}
                    alt="Build Trust "
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-4">
                    Having a well-designed business card, website, or marketing
                    materials and maintaining consistent design elements, you
                    can enhance the overall professional image of a business,
                    making it more trustworthy and credible.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-pink mb-3">
                    Improve User Experience
                  </h1>
                  <Image
                    loading="lazy"
                    src={Me04}
                    alt="Improve User Experience"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-4">
                    Good design can improve the user experience by making it
                    easier for customers to understand information, navigate a
                    website or app, and engage with the brand.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-Me0">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-pink mb-3">
                    Effective Communication
                  </h1>
                  <Image
                    loading="lazy"
                    src={Me05}
                    alt="Effective Communication"
                    className="img-fluid mx-auto mb-3 w-75"
                  />
                  <p className="mt-4">
                    Design can also be used to communicate complex information
                    in an easily digestible format. With design, you can
                    simplify complex data and make it more engaging for your
                    customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-12 text-center Me0-heading-spr">
              <h1 className="lh-1">
                At ITP Asia, our design service provides a{" "}
                <span className="fw-bolder t-pink mb-3">
                  comprehensive one-stop solution
                </span>{" "}
              </h1>
              <h2 className="mb-3">
                for all your design needs. We focus on providing customized
                designs
              </h2>
              <h2 className="lh-1">
                that are not only{" "}
                <span className="fw-bolder t-pink mb-3">
                  visually appealing
                </span>{" "}
                but also{" "}
                <span className="fw-bolder t-pink mb-3">
                  effective in achieving your goals.
                </span>
              </h2>
              <h1 className="my-3">Our service include but not limited to</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bv">
              <h3 className="t-white">
                Here are some of our work that may inspire you!
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">Web Design</h1>
                      <p className="mt-5 t-white">
                        In today's digital age, having a website is crucial for
                        any business. A well-designed and developed website not
                        only provides a professional image for your business but
                        also helps to attract and retain customers. It allows
                        your business to showcase products or services, share
                        important information, and communicate with your
                        customers.
                      </p>

                      <p className="t-white">
                        With our help of professional website design and
                        development services, you can create a website that
                        tailored to your specific needs and goals, and stay
                        ahead of your competitors in the digital landscape.{" "}
                      </p>

                      <p className="t-white mb-0">Our service includes:</p>
                      <ul>
                        <li>Company website</li>
                        <li>CRM & DRM website</li>
                        <li>Sales and Dealers Support website</li>
                        <li>VR Experience</li>
                        <li> Etc.</li>
                      </ul>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[0]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[1]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[2]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[3]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">
                        Digital Content Design
                      </h1>
                      <p className="mt-5 t-white">
                        Our comprehensive digital content creation service
                        offers a wide range of solutions, from sophisticated
                        graphic design to top-quality video production, all
                        customized to meet your specific budget requirements.
                      </p>

                      <p className="t-white">
                        Our team is highly skilled in the art of visual
                        communication and dedicated to delivering impactful
                        designs that effectively convey your message and achieve
                        your goals. We take a tailored approach to each project,
                        working closely with you to understand your objectives
                        and incorporate them into the design process.
                      </p>
                      <p className="t-white">
                        Our ultimate aim is to produce content that is not only
                        visually stunning but also perfectly aligned with your
                        marketing strategy and overall business plan.
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[4]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[5]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[6]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[7]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner pin-black">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">Logo Design</h1>
                      <p className="mt-5 t-white">
                        A logo is the visual representation of a business, and
                        it serves as a crucial element in establishing brand
                        identity. A well-designed logo helps to differentiate
                        your business from your competitors, creates a memorable
                        image in the minds of customers, and promotes brand
                        recognition. It also communicates your company's values,
                        personality, and professionalism. A logo design service
                        can help your business create a unique and effective
                        logo that represents your brand identity and effectively
                        communicates the message to the target audience.
                      </p>

                      <p className="t-white">
                        By designing logos with us, your business can establish
                        a strong brand identity, increase credibility, and
                        improve marketability. Once a logo or mark is designed,
                        we provide ongoing support for its implementation and
                        upkeep as it will be utilized for a significant period
                        of time.
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Image
                        loading="lazy"
                        src={Me06}
                        alt="Logo Design"
                        className="img-fluid mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner  pin-black">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">Packaging Design</h1>
                      <p className="mt-5 t-white">
                        Having an effective and attractive packaging design is
                        critical for any business, as it is often the first
                        point of contact with potential customers. A
                        well-designed packaging can capture customers’
                        attention, communicate the brand's message, and
                        ultimately influence their purchasing decision.
                      </p>

                      <p className="t-white">
                        Our packaging design service can provide a fresh
                        perspective, expert guidance, and access to the latest
                        design technologies and trends. Additionally, we also
                        ensure that the final product meets technical
                        specifications and production requirements, minimizing
                        the risk of costly mistakes or delays. Let us enhance
                        your brand image, increase product sales, and gain a
                        competitive edge in the market with our packaging design
                        today.
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[8]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[9]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[10]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[11]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[12]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">
                        Posters & Flyers Design
                      </h1>
                      <p className="mt-5 t-white">
                        A well-designed poster or flyer can effectively
                        communicate important information about your business,
                        such as products, services, or upcoming events.
                      </p>

                      <p className="t-white">
                        With us, you can ensure that the poster or flyer is
                        created in a way that is visually appealing and
                        consistent with the brand's image and messaging. This
                        can help to create a cohesive and recognizable brand
                        identity, which can be crucial for establishing trust
                        and loyalty with your customers.
                      </p>

                      <p className="t-white">
                        Our expertise in the use of design principles such as
                        color, typography, and layout, ensuring that the poster
                        or flyer is easy to read and understand, and that
                        important information is emphasized appropriately.{" "}
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[13]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[14]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder">Catalog Design</h1>
                      <p className="mt-5 t-white">
                        We offer editorial design services for various
                        publications such as product catalogs for manufacturers
                        and department stores, company brochures, school
                        brochures, bridal and travel pamphlets. Our team
                        considers the publication's intended use and organizes
                        the information and structure of pages to attract reader
                        interest. We utilize appropriate color schemes and tones
                        for the content and arrange photos, diagrams,
                        illustrations, text, and other elements to ensure ease
                        of readability.
                      </p>

                      <p className="t-white">
                        With our expertise in printing and production, you can
                        trust that the final product meets the highest quality
                        standards, allowing it to reflect your brand identity
                        and message, and making it easier for customers to
                        remember and recognize the business.
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[15]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[16]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[17]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[18]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner pin-black">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder lh-1">
                        In-Store Tools Design and Construction
                      </h1>
                      <p className="mt-5 t-white">
                        Thinking about having a store with products but have no
                        idea what to consider or where to start? Our in-store
                        tools design and construction service covers it all. We
                        specialize in creating Point of Purchase (POP)
                        advertising, display stands, and large fixtures to drive
                        sales and increase brand awareness. With a successful
                        track record in industries ranging from home appliances
                        to construction materials, we can provide the expertise
                        you need to make your products stand out. We also
                        support on booth, store, and showroom design and
                        construction.
                      </p>

                      <p className="t-white">
                        With all of our experience and expertise, you can be
                        sure that your space will definitely showcase your brand
                        and products in a way that captivates and engages your
                        audience. Let us help you create a space that not only
                        attracts customers, but also inspires them to take
                        action.
                      </p>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Slide
                        slidesToScroll={1}
                        slidesToShow={1}
                        indicators={true}
                      >
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[19]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[20]})` }}
                          ></div>
                        </div>
                        <div className="each-slide-effect">
                          <div
                            style={{ backgroundImage: `url(${images[21]})` }}
                          ></div>
                        </div>
                      </Slide>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card_media-inner  pin-black">
                  <div className="row">
                    <div className="col-12 col-lg-6 pe-5 media_content-file_card position-relative">
                      <h1 className="t-white fw-bolder lh-1">
                        Drone Photography & Videography
                      </h1>
                      <p className="mt-5 t-white">
                        Drone photography and videography provide your business
                        with unique and visually stunning perspectives that
                        traditional photography and videography methods cannot
                        achieve. It allows your business to showcase your
                        products, services, and locations from an aerial
                        perspective, which can help to capture attention, create
                        a memorable impression, and stand out in a crowded
                        marketplace.
                      </p>

                      <p className="t-white mb-0">
                        We offer high-quality drone photography and videography
                        for any purpose, including
                      </p>
                      <ul>
                        <li>Tourism</li>
                        <li>Branding</li>
                        <li>Land and Infrastructure Management</li>
                        <li> Etc.</li>
                      </ul>
                    </div>
                    <div className="col-12 col-lg-6 media_img-file_card pt-5 mt-2">
                      <Image
                        loading="lazy"
                        src={Me07}
                        alt="Digital Content Creation"
                        className="img-fluid mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5 ev-heading-spr_bv">
              <h3 className="t-pink">Why with us?</h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex box-media  justify-content-start align-items-center">
                <Image loading="lazy" src={Me08} alt="" className="icon" />
                <h2 className="mb-0 t-white">
                  We not only complete projects efficiently,
                  <br />
                  But we also brainstorm and deliver optimal solutions{" "}
                  <span className="fw-bolder t-pink">
                    tailored to your business needs.
                  </span>
                </h2>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex box-media  justify-content-start align-items-center">
                <Image loading="lazy" src={Me08} alt="" className="icon" />
                <h2 className="mb-0 t-white">
                  Save your time and resources by having all your design needs{" "}
                  <br />
                  taken care of us with{" "}
                  <span className="fw-bolder t-pink">
                    our comprehensive one-stop service,{" "}
                  </span>
                  <br />
                  enabling you to work with us seamlessly without the need to
                  engage other providers.
                </h2>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex box-media  justify-content-start align-items-center">
                <Image loading="lazy" src={Me08} alt="" className="icon" />
                <h2 className="mb-0 t-white">
                  With our{" "}
                  <span className="fw-bolder t-pink">extensive expertise</span>{" "}
                  in all relevant areas,
                  <br />
                  Our team is committed to delivering{" "}
                  <span className="fw-bolder t-pink">
                    high-quality designs on time and within budget.
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h1 className="t-pink fw-bolder">
                Let our Design Service help elevate your business to the next
                level
                <br />
                with our professional and innovative designs.
              </h1>
              <h1>
                Contact us today to discuss how we can help you enhance your
                business
                <br />
                through our design solutions now.
              </h1>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default design_media;
